import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";

import '../scss/footer.scss';

const Footer = () => {
    
    let date = new Date();

    const [year, setYear] = useState(date.getFullYear());

    return (
        <footer>
            <Container>
                <Row className="">
                    <a href="https://www.marathonkuching.com/">Home</a>
                    |
                    <a href="https://www.marathonkuching.com/register/images/Privacy Policy.pdf">Privacy Policy</a>
                    |
                    <a href="https://www.marathonkuching.com/register/images/Signup T&C.pdf">Terms & Conditions</a>
                </Row>      
                {/* <Row className="font-button-group">
                    <a href="https://www.marathonkuching.com/"><FontAwesomeIcon icon={faFacebook} /></a>
                    <a href="https://www.marathonkuching.com/register/images/Privacy Policy.pdf"><FontAwesomeIcon icon={ faTwitter } /></a>
                    <a href="https://www.marathonkuching.com/register/images/Signup T&C.pdf"><FontAwesomeIcon icon={ faInstagram } /></a>
                </Row>           */}
                <Row className="">
                    <p>
                        Copyright &#169; {year} Kuching Marathon. All Rights Reserved<br/>
                        Website by Neudimenxion
                    </p>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;